// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
/* Document
   ========================================================================== */
/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */
html {
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

/* Sections
     ========================================================================== */
/**
   * Remove the margin in all browsers.
   */
body {
  margin: 0;
}

/**
   * Render the \`main\` element consistently in IE.
   */
main {
  display: block;
}

/**
   * Correct the font size and margin on \`h1\` elements within \`section\` and
   * \`article\` contexts in Chrome, Firefox, and Safari.
   */
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
     ========================================================================== */
/**
   * 1. Add the correct box sizing in Firefox.
   * 2. Show the overflow in Edge and IE.
   */
hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}

/**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd \`em\` font sizing in all browsers.
   */
pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/* Text-level semantics
     ========================================================================== */
/**
   * Remove the gray background on active links in IE 10.
   */
a {
  background-color: transparent;
}

/**
   * 1. Remove the bottom border in Chrome 57-
   * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
   */
abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  text-decoration: underline dotted; /* 2 */
}

/**
   * Add the correct font weight in Chrome, Edge, and Safari.
   */
b,
strong {
  font-weight: bolder;
}

/**
   * 1. Correct the inheritance and scaling of font size in all browsers.
   * 2. Correct the odd \`em\` font sizing in all browsers.
   */
code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/**
   * Add the correct font size in all browsers.
   */
small {
  font-size: 80%;
}

/**
   * Prevent \`sub\` and \`sup\` elements from affecting the line height in
   * all browsers.
   */
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
     ========================================================================== */
/**
   * Remove the border on images inside links in IE 10.
   */
img {
  border-style: none;
}

/* Forms
     ========================================================================== */
/**
   * 1. Change the font styles in all browsers.
   * 2. Remove the margin in Firefox and Safari.
   */
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}

/**
   * Show the overflow in IE.
   * 1. Show the overflow in Edge.
   */
button,
input {
  /* 1 */
  overflow: visible;
}

/**
   * Remove the inheritance of text transform in Edge, Firefox, and IE.
   * 1. Remove the inheritance of text transform in Firefox.
   */
button,
select {
  /* 1 */
  text-transform: none;
}

/**
   * Correct the inability to style clickable types in iOS and Safari.
   */
button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

/**
   * Remove the inner border and padding in Firefox.
   */
button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
   * Restore the focus styles unset by the previous rule.
   */
button:-moz-focusring,
[type=button]:-moz-focusring,
[type=reset]:-moz-focusring,
[type=submit]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
   * Correct the padding in Firefox.
   */
fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
   * 1. Correct the text wrapping in Edge and IE.
   * 2. Correct the color inheritance from \`fieldset\` elements in IE.
   * 3. Remove the padding so developers are not caught out when they zero out
   *    \`fieldset\` elements in all browsers.
   */
legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}

/**
   * Add the correct vertical alignment in Chrome, Firefox, and Opera.
   */
progress {
  vertical-align: baseline;
}

/**
   * Remove the default vertical scrollbar in IE 10+.
   */
textarea {
  overflow: auto;
}

/**
   * 1. Add the correct box sizing in IE 10.
   * 2. Remove the padding in IE 10.
   */
[type=checkbox],
[type=radio] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
   * Correct the cursor style of increment and decrement buttons in Chrome.
   */
[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

/**
   * 1. Correct the odd appearance in Chrome and Safari.
   * 2. Correct the outline style in Safari.
   */
[type=search] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/**
   * Remove the inner padding in Chrome and Safari on macOS.
   */
[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
   * 1. Correct the inability to style clickable types in iOS and Safari.
   * 2. Change font properties to \`inherit\` in Safari.
   */
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/* Interactive
     ========================================================================== */
/*
   * Add the correct display in Edge, IE 10+, and Firefox.
   */
details {
  display: block;
}

/*
   * Add the correct display in all browsers.
   */
summary {
  display: list-item;
}

/* Misc
     ========================================================================== */
/**
   * Add the correct display in IE 10+.
   */
template {
  display: none;
}

/**
   * Add the correct display in IE 10.
   */
[hidden] {
  display: none;
}

.text-align-left {
  text-align: left;
}

.text-align-center {
  text-align: center;
}

.text-align-right {
  text-align: right;
}

body {
  font-family: "Lato", "Noto Sans JP", "ヒラギノ角ゴ ProN", "Hiragino Kaku Gothic ProN", "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
}

button {
  border: none;
  background-color: transparent;
  outline: none;
}

.nf-page {
  padding-top: 60px;
  min-height: 100vh;
}

.nf-text-required-style {
  color: #990000;
  font-size: 0.75rem;
  font-weight: bold;
}

.nf-analyze-required::after {
  content: "*";
  font-size: 0.875rem;
  text-align: right;
  color: #990000;
}

.content-body {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.display-linebreak {
  white-space: pre-line;
}

.validation-error {
  font-size: 0.625rem;
  color: #990000;
  padding-left: 10px;
}
.validation-error.error-title-image {
  padding-left: 20px;
}
.validation-error.error-remand-reason {
  position: absolute;
  right: 2px;
  bottom: -5px;
}
.validation-error.error-images {
  position: absolute;
  right: 20px;
}

.sort-span:hover {
  cursor: pointer;
}

.action-container {
  display: flex;
  justify-content: center;
  position: relative;
}

.disabled-area:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
  background: rgba(255, 255, 255, 0.5);
}

span.text-title {
  font-size: 1rem;
}

span.close-icon {
  position: absolute;
  right: -11px;
  top: -11px;
  font-size: 22px !important;
  z-index: 1;
}

span.text-tip {
  font-size: 0.75rem;
  color: #000000;
}
span.text-tip .text-subtip {
  margin-left: 10px;
  color: #000000;
  font-weight: normal;
}

.text-required::after {
  content: "*";
  color: #990000;
  font-size: 0.875rem;
}

.text-blog-code {
  margin: 10px 0;
}

ul:not([data-slate-node=element]) {
  list-style: none;
}

.ant-table-thead > tr > th {
  font-weight: bolder;
  background-color: #f3f3f3;
}

.ant-table-column-sorter {
  visibility: collapse;
}

.ant-table-ping-left:not(.ant-table-has-fix-left) .ant-table-container::before {
  box-shadow: none;
}

.ant-table-ping-left .ant-table-cell-fix-left-first::after,
.ant-table-ping-left .ant-table-cell-fix-left-last::after {
  box-shadow: none;
}

.ant-table-ping-right:not(.ant-table-has-fix-right) .ant-table-container::after {
  box-shadow: none;
}

.ant-table-ping-right .ant-table-cell-fix-right-first::after,
.ant-table-ping-right .ant-table-cell-fix-right-last::after {
  box-shadow: none;
}

.ant-pagination-item-active {
  border: none !important;
}
.ant-pagination-item-active a {
  color: #000000 !important;
}

.ant-pagination-item a {
  color: #808080;
}
.ant-pagination-item a:hover {
  color: #808080;
}

.ant-pagination-options {
  display: none !important;
}

.ant-pagination-prev,
.ant-pagination-next,
.ant-pagination-item-link {
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
}

.ant-pagination-item-link:hover span {
  color: #808080 !important;
}

.ant-pagination-disabled .ant-pagination-item-link:hover span {
  cursor: not-allowed !important;
}

.ant-pagination-disable span.anticon:hover,
.ant-pagination-disable span svg {
  cursor: not-allowed !important;
  background-color: red;
}

.ant-pagination-item-link-icon .pagination-jump-next {
  color: #808080 !important;
}

.ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-link-icon,
.ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-link-icon {
  color: #808080 !important;
}

.ant-select-arrow {
  color: #000000;
}

.ant-select-item-option {
  background-color: #ffffff !important;
  font-size: 11px;
}

.ant-select-item-option {
  background-color: #ffffff !important;
  font-size: 11px;
}

.ant-modal-wrap {
  text-align: center;
}
.ant-modal-wrap .ant-modal {
  top: 0;
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

.ant-modal-wrap::before {
  display: inline-block;
  width: 0;
  height: 100%;
  vertical-align: middle;
  content: "";
}

.ant-modal-header {
  border-bottom: none;
}

.ant-modal-body {
  padding-top: 0;
}

.ant-modal-content {
  border-radius: 7px;
  overflow-y: hidden;
  overflow-x: hidden;
  max-height: 80vh;
  height: 100%;
}

.ant-modal-body {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 80vh;
  height: 100%;
}

.ant-modal-body::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.ant-modal-body::-webkit-scrollbar-thumb {
  background: #808080;
  border-radius: 5px;
}

.ant-modal-body::-webkit-scrollbar-track {
  background: rgb(91.1176470588%, 91.1176470588%, 91.1176470588%);
  border-radius: 5px;
}

.ant-upload.ant-upload-select-picture-card {
  border: none;
  height: 200px;
  width: 150px;
}

.ant-picker-footer {
  display: none;
}

.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
  background-color: #000000;
}

.ant-picker-focused {
  outline: none;
  box-shadow: 0 0 0 1px #000000;
  border: 1px solid transparent;
}

.ant-picker:hover {
  border: 1px solid transparent;
}

.ant-picker,
.ant-picker.ant-picker-disabled {
  border: none !important;
  outline: none;
}

.ant-picker-focused {
  border-color: #000000;
}

.ant-picker {
  background-color: #f3f3f3;
  border: 1px solid transparent;
}

.ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
  border: 1px solid #000000;
}

.ant-input,
.ant-select-selector,
.ant-input-password,
.ant-input-number {
  border: 1px solid transparent !important;
}

.ant-input:focus,
.ant-input-focused,
.ant-input-number:focus,
.ant-input-number-focused {
  box-shadow: 0 0 0 1px #000000;
}

.ant-input-number-input {
  padding: 0 0;
}

.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
  box-shadow: 0 0 0 1px #000000;
}

.ant-checkbox .ant-checkbox-inner {
  background-color: white;
  border-color: #bdbdbd;
}

.ant-checkbox-checked .ant-checkbox-inner {
  content: "✓" !important;
  color: #000000;
  -webkit-user-select: none;
          user-select: none;
}
.ant-checkbox-checked .ant-checkbox-inner::after {
  top: 2.5px;
  left: 0;
  border: 3px solid #51535b;
  text-align: center;
  line-height: 10px;
  border-radius: 3px;
  font-weight: bold;
  background-color: none;
  display: table;
  border: 0;
  opacity: 1;
  content: "✓" !important;
  font-size: 18px;
  transform: rotateX(45deg);
  transition: none;
}

.ant-checkbox-wrapper:hover .ant-checkbox-inner,
.ant-checkbox:hover .ant-checkbox-inner,
.ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color: #bdbdbd;
}

.ant-checkbox {
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1607843137);
}

.ant-checkbox-indeterminate .ant-checkbox-inner::after {
  background-color: #51535b;
}

.anticon:hover {
  cursor: pointer;
}

.ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0;
}

.ant-table-thead {
  -webkit-user-select: none;
          user-select: none;
  background-color: #f3f3f3;
}

.ant-table-tbody > tr.ant-table-row-selected > td {
  background: #f3f3f3;
  border-color: rgba(0, 0, 0, 0.03);
}

.ant-table-sticky-scroll-bar {
  display: none;
}

.ant-image-img {
  object-fit: cover;
}

.ant-image-preview-img {
  max-width: 70%;
  max-height: 70%;
}

.table-colum-title-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: auto;
}

.btn-area {
  width: 100%;
  padding-top: 50px;
  display: flex;
  justify-content: center;
}

.anticon[disabled]:hover {
  cursor: not-allowed;
  opacity: 1;
}

.anticon:not(.display-icon):hover {
  opacity: 0.5;
}

.ant-input-number-handler-up-disabled,
.ant-input-number-handler-down-disabled {
  cursor: pointer;
}

.live-signup .live-edit-area {
  position: relative;
  margin: 0 15px 35px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px #f0f0f0;
  padding: 35px 30px 0px 30px;
  font-size: 1rem;
}
.live-signup .live-edit-area .images-container::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.live-signup .live-edit-area .images-container::-webkit-scrollbar-thumb {
  background: #808080;
  border-radius: 5px;
}
.live-signup .live-edit-area .images-container::-webkit-scrollbar-track {
  background: rgb(91.1176470588%, 91.1176470588%, 91.1176470588%);
  border-radius: 5px;
}
.live-signup .live-edit-area .images-container {
  max-height: 400px;
  overflow-y: scroll;
  margin: 20px auto;
  padding-top: 12px;
  display: flex;
  flex-wrap: wrap;
}
.live-signup .live-edit-area .images-container .live-image-container {
  display: flex;
  transform: translate3d(0, 0, 0);
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
}
.live-signup .live-edit-area .images-container .live-image-container span {
  font-size: 0.75rem;
}
.live-signup .live-edit-area .images-container .live-image-container {
  margin-bottom: 10px;
}
.live-signup .live-edit-area .images-container .image-number {
  font-size: 0.75rem;
}
.live-signup .live-edit-area .images-container .image-select {
  position: relative;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 3px;
}
.live-signup .live-edit-area .images-container .image-select .nf-btn {
  border-width: 2px;
  width: 90px;
  margin: 0;
  margin-bottom: 12px;
  font-size: 0.75rem;
}
.live-signup .live-edit-area .images-container .image-select,
.live-signup .live-edit-area .images-container .image-select .live-img {
  min-height: 150px;
  width: 120px;
}
.live-signup .live-edit-area .images-container .image-select .product-detail,
.live-signup .live-edit-area .images-container .image-select .live-img .product-detail {
  line-height: 15px;
}
.live-signup .live-edit-area .images-container .product-info .ant-image-img {
  height: 92px;
  width: 100px;
}
.live-signup .live-edit-area .deliverer-title-area {
  margin-top: 5px;
  display: flex;
  flex-direction: row;
}
.live-signup .live-edit-area .deliverer-title-area .deliverer-close-icon {
  margin-top: 1px;
  margin-left: 5px;
  font-size: 0.875rem;
}
.live-signup .live-edit-area .select-container {
  display: flex;
}
.live-signup .live-edit-area .select-container div:first-child label {
  margin-right: 10px;
  text-align: left;
}
.live-signup .live-edit-area .select-container label {
  width: 55px;
}
.live-signup .live-edit-area .select-container-bottom {
  display: flex;
}
.live-signup .live-edit-area .select-container-bottom div:first-child label {
  margin-right: 10px;
  text-align: left;
}
.live-signup .live-edit-area .select-container-bottom label {
  width: 75px;
}
.live-signup .live-edit-area .select-container-bottom .nf-select {
  width: 280px;
}
.live-signup .live-edit-area .select-container-bottom .nf-select.select-inline-grey {
  width: 100px;
}
.live-signup .live-edit-area .select-container-bottom .nf-input-wrapper:not(:first-child) {
  margin-left: 20px;
}
.live-signup .live-edit-area .info-area {
  margin: 10px 0 30px;
}
.live-signup .live-edit-area .info-area span {
  font-size: 0.75rem;
  padding-right: 20px;
}
.live-signup .live-edit-area .tag-area {
  margin-top: 30px;
  margin-bottom: 25px;
}
.live-signup .live-edit-area .tag-area .tag-title {
  margin-bottom: 10px;
}
.live-signup .live-edit-area .tag-area .nf-select {
  width: 140px;
}
.live-signup .live-edit-area .tag-area .nf-btn {
  width: 100px;
}
.live-signup .live-edit-area .tag-area .text-tag {
  font-size: 0.75rem;
  display: inline-block;
  width: 70px;
}
.live-signup .live-edit-area .tag-area .tags-container {
  display: flex;
  flex-wrap: wrap;
  max-width: 450px;
  margin-bottom: 30px;
}
.live-signup .live-edit-area .tag-area .tags-container .tag {
  font-size: 0.75rem;
  padding: 5px 22px;
  margin: 6px 15px 6px 0;
  background-color: #bdbdbd;
  border-radius: 2px;
  position: relative;
  overflow: visible;
}
.live-signup .live-edit-area .user-info-area {
  margin-bottom: 30px;
  width: 280px;
}
.live-signup .live-edit-area .user-info-area .nf-input-wrapper {
  margin-top: 10px;
}
.live-signup .live-edit-area .user-info-area .nf-select {
  width: 200px;
}
.live-signup .live-edit-area .user-info-area .nf-text-after {
  right: -21px;
}
.live-signup .live-edit-area .title-area {
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
}
.live-signup .live-edit-area .title-area .nf-input-error {
  right: auto;
  margin-left: 220px;
}
.live-signup .live-edit-area .description-area {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
.live-signup .live-edit-area .description-area textarea {
  font-size: 0.75rem;
  padding: 9px 10px;
  resize: none;
  border: none;
  border-radius: 3px;
  background-color: #f3f3f3;
  height: 60px;
}
.live-signup .live-edit-area .description-area textarea:focus-visible {
  outline-style: none;
  box-shadow: 0 0 0 1px #000000;
}
.live-signup .live-edit-area .description-area textarea:disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
  opacity: 1;
}
.live-signup .live-edit-area .description-area textarea::placeholder {
  color: rgba(0, 0, 0, 0.25);
}
.live-signup .live-edit-area .description-area .textarea-error {
  color: #990000;
  position: absolute;
  right: 30px;
  font-size: 0.625rem;
}
.live-signup .live-edit-area .image-area {
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
}
.live-signup .live-edit-area .image-area .image-select-area {
  display: flex;
  flex-direction: row;
}
.live-signup .live-edit-area .image-area .image-select-area .image-select {
  position: relative;
  height: 200px;
  width: 150px;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  margin: 20px;
  margin-bottom: 3px;
}
.live-signup .live-edit-area .image-area .image-select-area .image-select .nf-btn {
  border-width: 2px;
  margin: 0;
  margin-bottom: 17px;
  font-size: 0.75rem;
}
.live-signup .live-edit-area .image-area .image-select-area .image-select-label {
  text-align: center;
  font-size: 0.75rem;
  margin-bottom: 20px;
}
.live-signup .live-edit-area .check-area {
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
}
.live-signup .live-edit-area .check-area .nf-checkbox-wrapper {
  display: flex;
}
.live-signup .live-edit-area .check-area .nf-checkbox-wrapper div {
  margin-right: 15px;
}
.live-signup .live-edit-area .check-area .nf-checkbox-wrapper div label {
  font-size: 0.75rem;
}
.live-signup .live-edit-area .check-area .nf-checkbox-wrapper div label::before {
  font-size: 0.625rem;
}
.live-signup .live-edit-area .public-date-select {
  font-size: 0.75rem;
  position: relative;
  display: flex;
  align-items: center;
}
.live-signup .live-edit-area .public-date-select.select-flex-top {
  align-items: flex-start;
}
.live-signup .live-edit-area .public-date-select .ant-picker {
  width: 120px;
  margin: 0 10px 0 20px;
  height: 32px;
}
.live-signup .live-edit-area .public-date-select .ant-picker input {
  font-size: 0.75rem;
}
.live-signup .live-edit-area .public-date-select .ant-picker .anticon-close-circle {
  background-color: #f3f3f3;
}
.live-signup .live-edit-area .public-date-select .nf-input-wrapper {
  width: 80px;
  margin-right: 20px;
}
.live-signup .live-edit-area .public-date-select .text-checkbox-label {
  margin: 0 30px 0 17px;
}
.live-signup .live-edit-area .public-date-select textarea {
  flex: 1 1;
  padding: 8px 8px;
  resize: none;
  border: none;
  background-color: #f3f3f3;
  height: 70px;
  border-radius: 3px;
}
.live-signup .live-edit-area .public-date-select textarea:focus-visible {
  outline-style: none;
  box-shadow: 0 0 0 1px #000000;
}
.live-signup .live-edit-area .remand-area {
  display: flex;
  position: relative;
  margin-top: 40px;
}
.live-signup .live-edit-area .remand-area .text-remind {
  margin-left: 55px;
  font-size: 0.625rem;
  transform: scale(0.9);
  transform-origin: left bottom;
  display: inline-block;
  color: #000000;
  font-weight: normal;
}
.live-signup .live-edit-area .addButton {
  text-decoration: underline;
  font-size: 0.875rem;
  text-align: right;
  cursor: pointer;
}
.live-signup .live-edit-area .addButton:hover {
  opacity: 0.5;
}
.live-signup .normal-label {
  font-size: 0.75rem;
}

.live-signup .live-edit-area:first-child {
  margin-bottom: 20px;
  padding-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/modal/liveSignUpModal/style.scss","webpack://./src/styles/_normalize.scss","webpack://./src/styles/_global.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/_mixin.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,2EAAA;AAEA;+EAAA;AAGA;;;EAAA;AAKA;EACE,iBAAA,EAAA,MAAA;EACA,8BAAA,EAAA,MAAA;ADDF;;ACIA;iFAAA;AAGA;;IAAA;AAIA;EACE,SAAA;ADHF;;ACMA;;IAAA;AAIA;EACE,cAAA;ADJF;;ACOA;;;IAAA;AAKA;EACE,cAAA;EACA,gBAAA;ADLF;;ACQA;iFAAA;AAGA;;;IAAA;AAKA;EACE,uBAAA,EAAA,MAAA;EACA,SAAA,EAAA,MAAA;EACA,iBAAA,EAAA,MAAA;ADPF;;ACUA;;;IAAA;AAKA;EACE,iCAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;ADRF;;ACWA;iFAAA;AAGA;;IAAA;AAIA;EACE,6BAAA;ADVF;;ACaA;;;IAAA;AAKA;EACE,mBAAA,EAAA,MAAA;EACA,0BAAA,EAAA,MAAA;EACA,iCAAA,EAAA,MAAA;ADXF;;ACcA;;IAAA;AAIA;;EAEE,mBAAA;ADZF;;ACeA;;;IAAA;AAKA;;;EAGE,iCAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;ADbF;;ACgBA;;IAAA;AAIA;EACE,cAAA;ADdF;;ACiBA;;;IAAA;AAKA;;EAEE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;ADfF;;ACkBA;EACE,eAAA;ADfF;;ACkBA;EACE,WAAA;ADfF;;ACkBA;iFAAA;AAGA;;IAAA;AAIA;EACE,kBAAA;ADjBF;;ACoBA;iFAAA;AAGA;;;IAAA;AAKA;;;;;EAKE,oBAAA,EAAA,MAAA;EACA,eAAA,EAAA,MAAA;EACA,iBAAA,EAAA,MAAA;EACA,SAAA,EAAA,MAAA;ADnBF;;ACsBA;;;IAAA;AAKA;;EAEE,MAAA;EACA,iBAAA;ADpBF;;ACuBA;;;IAAA;AAKA;;EAEE,MAAA;EACA,oBAAA;ADrBF;;ACwBA;;IAAA;AAIA;;;;EAIE,0BAAA;ADtBF;;ACyBA;;IAAA;AAIA;;;;EAIE,kBAAA;EACA,UAAA;ADvBF;;AC0BA;;IAAA;AAIA;;;;EAIE,8BAAA;ADxBF;;AC2BA;;IAAA;AAIA;EACE,8BAAA;ADzBF;;AC4BA;;;;;IAAA;AAOA;EACE,sBAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;EACA,eAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;EACA,mBAAA,EAAA,MAAA;AD1BF;;AC6BA;;IAAA;AAIA;EACE,wBAAA;AD3BF;;AC8BA;;IAAA;AAIA;EACE,cAAA;AD5BF;;AC+BA;;;IAAA;AAKA;;EAEE,sBAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;AD7BF;;ACgCA;;IAAA;AAIA;;EAEE,YAAA;AD9BF;;ACiCA;;;IAAA;AAKA;EACE,6BAAA,EAAA,MAAA;EACA,oBAAA,EAAA,MAAA;AD/BF;;ACkCA;;IAAA;AAIA;EACE,wBAAA;ADhCF;;ACmCA;;;IAAA;AAKA;EACE,0BAAA,EAAA,MAAA;EACA,aAAA,EAAA,MAAA;ADjCF;;ACoCA;iFAAA;AAGA;;IAAA;AAIA;EACE,cAAA;ADnCF;;ACsCA;;IAAA;AAIA;EACE,kBAAA;ADpCF;;ACuCA;iFAAA;AAGA;;IAAA;AAIA;EACE,aAAA;ADtCF;;ACyCA;;IAAA;AAIA;EACE,aAAA;ADvCF;;AErTE;EACE,gBAAA;AFwTJ;;AEzTE;EACE,kBAAA;AF4TJ;;AE7TE;EACE,iBAAA;AFgUJ;;AE5TA;EACE,qICoBY;AH2Sd;;AE5TA;EACE,YAAA;EACA,6BAAA;EACA,aAAA;AF+TF;;AE5TA;EACE,iBAAA;EACA,iBAAA;AF+TF;;AE5TA;EACE,cCrBS;EDsBT,kBAAA;EACA,iBAAA;AF+TF;;AE5TA;EACE,YAAA;EACA,mBCPa;EDQb,iBAAA;EACA,cC5BS;AH2VX;;AE5TA;EAEE,aAAA;EACA,sBAAA;EACA,iBAAA;AF8TF;;AE5TA;EACE,qBAAA;AF+TF;;AE5TA;EACE,mBCrBe;EDsBf,cC3CS;ED4CT,kBAAA;AF+TF;AE9TE;EACE,kBAAA;AFgUJ;AE9TE;EACE,kBAAA;EACA,UAAA;EACA,YAAA;AFgUJ;AE9TE;EACE,kBAAA;EACA,WAAA;AFgUJ;;AE3TE;EACE,eAAA;AF8TJ;;AE1TA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;AF6TF;;AE1TA;EExDE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oCAAA;AJsXF;;AEnUA;EACE,eC/De;AHqYjB;;AEpUA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,0BAAA;EACA,UAAA;AFuUF;;AErUA;EACE,kBClEc;EDmEd,cChFM;AHwZR;AEvUE;EACE,iBAAA;EACA,cCnFI;EDoFJ,mBAAA;AFyUJ;;AIxYE;EACE,YAAA;EACA,cDhCO;ECiCP,mBDZW;AHuZf;;AEzUA;EACE,cAAA;AF4UF;;AEzUA;EACE,gBAAA;AF4UF;;AEzUA;EACE,mBAAA;EACA,yBCzGK;AHqbP;;AE1UA;EACE,oBAAA;AF6UF;;AE3UA;EACE,gBAAA;AF8UF;;AE5UA;;EAEE,gBAAA;AF+UF;;AE7UA;EACE,gBAAA;AFgVF;;AE9UA;;EAEE,gBAAA;AFiVF;;AE9UA;EACE,uBAAA;AFiVF;AEhVE;EACE,yBAAA;AFkVJ;;AE/UA;EACE,cCnIU;AHqdZ;AEjVE;EACE,cCrIQ;AHwdZ;;AEhVA;EACE,wBAAA;AFmVF;;AEhVA;;;EAGE,wBAAA;EACA,uBAAA;EACA,2BAAA;AFmVF;;AEhVE;EACE,yBAAA;AFmVJ;;AE/UE;EACE,8BAAA;AFkVJ;;AE7UE;;EAEE,8BAAA;EACA,qBAAA;AFgVJ;;AE5UA;EACE,yBAAA;AF+UF;;AE5UA;;EAME,yBAAA;AF2UF;;AExUA;EACE,cChLM;AH2fR;;AExUA;EACE,oCAAA;EACA,eAAA;AF2UF;;AExUA;EACE,oCAAA;EACA,eAAA;AF2UF;;AExUA;EACE,kBAAA;AF2UF;AE1UE;EACE,MAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;AF4UJ;;AExUA;EACE,qBAAA;EACA,QAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;AF2UF;;AExUA;EACE,mBAAA;AF2UF;;AExUA;EACE,cAAA;AF2UF;;AExUA;EACE,kBCrJoB;EDsJpB,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AF2UF;;AExUA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AF2UF;;AExUA;EACE,WAAA;EACA,YAAA;AF2UF;;AEzUA;EACE,mBC/OU;EDgPV,kBAAA;AF4UF;;AE1UA;EACE,+DAAA;EACA,kBAAA;AF6UF;;AE1UA;EACE,YAAA;EACA,aC/K2B;EDgL3B,YCjL0B;AH8f5B;;AE1UA;EACE,aAAA;AF6UF;;AE3UA;EACE,yBC7PM;AH2kBR;;AE5UA;EACE,aAAA;EACA,6BAAA;EACA,6BAAA;AF+UF;;AE7UA;EACE,6BAAA;AFgVF;;AE9UA;;EAEE,uBAAA;EACA,aAAA;AFiVF;;AE9UA;EACE,qBC9QM;AH+lBR;;AE/UA;EACE,yBCtRK;EDuRL,6BAAA;AFkVF;;AEhVA;EACE,yBAAA;AFmVF;;AE/UA;;;;EAIE,wCAAA;AFkVF;;AE/UA;;;;EAKE,6BAAA;AFiVF;;AE/UA;EAEE,YAAA;AFiVF;;AE9UA;EAEE,6BAAA;AFgVF;;AEzUA;EACE,uBAAA;EACA,qBCzTW;AHqoBb;;AE1UA;EAGE,uBAAA;EACA,cC7TM;ED8TN,yBAAA;UAAA,iBAAA;AF2UF;AEzUE;EACE,UAAA;EACA,OAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AF2UJ;;AExUA;;;EAGE,qBCvVW;AHkqBb;;AEzUA;EACE,mDAAA;AF4UF;;AE1UA;EACE,yBAAA;AF6UF;;AEzUE;EACE,eAAA;AF4UJ;;AExUA;EAGE,QAAA;AFyUF;;AEvUA;EACE,yBAAA;UAAA,iBAAA;EACA,yBChXK;AH0rBP;;AExUA;EACE,mBCnXK;EDoXL,iCAAA;AF2UF;;AEzUA;EACE,aAAA;AF4UF;;AE1UA;EACE,iBAAA;AF6UF;;AE3UA;EACE,cAAA;EACA,eAAA;AF8UF;;AE5UA;EACE,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,YAAA;AF+UF;;AE7UA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;AFgVF;;AE9UA;EACE,mBAAA;EACA,UAAA;AFiVF;;AE/UA;EACE,YAAA;AFkVF;;AEhVA;;EAEE,eAAA;AFmVF;;AAzuBI;EACI,kBAAA;EACA,mBAAA;EIPN,kBADyB;EAEzB,gCAAA;EJQM,2BAAA;EACA,eGKS;AHwuBjB;AA5uBQ;EACI,WAAA;EACA,YAAA;AA8uBZ;AA5uBQ;EACI,mBGXA;EHYA,kBAAA;AA8uBZ;AA5uBQ;EACI,+DAAA;EACA,kBAAA;AA8uBZ;AA5uBQ;EACI,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AA8uBZ;AA7uBY;EACI,aAAA;EACA,+BAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AA+uBhB;AA9uBgB;EACI,kBGfJ;AH+vBhB;AAvvBY;EASI,mBAAA;AAivBhB;AA/uBY;EACI,kBGpBA;AHqwBhB;AA/uBY;EACI,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAivBhB;AAhvBgB;EACI,iBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,kBGnCJ;AHqxBhB;AA/uBY;;EAEI,iBAAA;EACA,YAAA;AAivBhB;AAhvBgB;;EACI,iBAAA;AAmvBpB;AAhvBY;EACI,YAAA;EACA,YAAA;AAkvBhB;AA/uBQ;EACI,eAAA;EACA,aAAA;EACA,mBAAA;AAivBZ;AAhvBY;EACI,eAAA;EACA,gBAAA;EACA,mBG3DD;AH6yBf;AA/uBQ;EACI,aAAA;AAivBZ;AA/uBgB;EACI,kBAAA;EACA,gBAAA;AAivBpB;AA9uBY;EACI,WAAA;AAgvBhB;AA7uBQ;EACI,aAAA;AA+uBZ;AA7uBgB;EACI,kBAAA;EACA,gBAAA;AA+uBpB;AA5uBY;EACI,WAAA;AA8uBhB;AA5uBY;EACI,YGvEF;AHqzBd;AA7uBgB;EACI,YAAA;AA+uBpB;AA5uBY;EACI,iBAAA;AA8uBhB;AAvuBQ;EACI,mBAAA;AAyuBZ;AAxuBY;EACI,kBGrGA;EHsGA,mBAAA;AA0uBhB;AAvuBQ;EACI,gBAAA;EACA,mBAAA;AAyuBZ;AAxuBY;EACI,mBAAA;AA0uBhB;AAxuBY;EACI,YAAA;AA0uBhB;AAxuBY;EACI,YAAA;AA0uBhB;AAxuBY;EACI,kBGtHA;EHuHA,qBAAA;EACA,WAAA;AA0uBhB;AAxuBY;EACI,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA0uBhB;AAzuBgB;EACI,kBGhIJ;EHiII,iBAAA;EACA,sBAAA;EACA,yBGlJP;EHmJO,kBAAA;EACA,kBAAA;EACA,iBAAA;AA2uBpB;AAvuBQ;EACI,mBAAA;EACA,YAAA;AAyuBZ;AAxuBY;EACI,gBAAA;AA0uBhB;AAxuBY;EACI,YAAA;AA0uBhB;AAxuBY;EACI,YAAA;AA0uBhB;AAvuBQ;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;AAyuBZ;AAxuBY;EACI,WAAA;EACA,kBAAA;AA0uBhB;AAvuBQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AAyuBZ;AAxuBY;EACI,kBGrKA;EHsKA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBG5LT;EH6LS,YAAA;AA0uBhB;AAzuBgB;EACI,mBAAA;EACA,6BAAA;AA2uBpB;AAzuBgB;EACI,0BAAA;EACA,mBAAA;EACA,UAAA;AA2uBpB;AAzuBgB;EACI,0BAAA;AA2uBpB;AAxuBY;EACI,cG9ML;EH+MK,kBAAA;EACA,WAAA;EACA,mBG5LC;AHs6BjB;AAvuBQ;EACI,aAAA;EACA,sBAAA;EACA,oBAAA;AAyuBZ;AAxuBY;EACI,aAAA;EACA,mBAAA;AA0uBhB;AAzuBgB;EACI,kBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AA2uBpB;AA1uBoB;EACI,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBGtNR;AHk8BhB;AAzuBgB;EACI,kBAAA;EACA,kBG3NJ;EH4NI,mBAAA;AA2uBpB;AAvuBQ;EACI,aAAA;EACA,sBAAA;EACA,oBAAA;AAyuBZ;AAxuBY;EACI,aAAA;AA0uBhB;AAzuBgB;EACI,kBAAA;AA2uBpB;AA1uBoB;EACI,kBGzOR;AHq9BhB;AA3uBwB;EACI,mBG1OX;AHu9BjB;AAvuBQ;EACI,kBGlPI;EHmPJ,kBAAA;EACA,aAAA;EACA,mBAAA;AAyuBZ;AAxuBY;EACI,uBAAA;AA0uBhB;AAxuBY;EACI,YAAA;EACA,qBAAA;EACA,YAAA;AA0uBhB;AAzuBgB;EACI,kBG9PJ;AHy+BhB;AAzuBgB;EACI,yBGnRb;AH8/BP;AAxuBY;EACI,WAAA;EACA,kBAAA;AA0uBhB;AAxuBY;EACI,qBAAA;AA0uBhB;AAxuBY;EACI,SAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,yBGlST;EHmSS,YAAA;EACA,kBAAA;AA0uBhB;AAzuBgB;EACI,mBAAA;EACA,6BAAA;AA2uBpB;AAvuBQ;EACI,aAAA;EACA,kBAAA;EACA,gBAAA;AAyuBZ;AAxuBY;EACI,iBAAA;EI3Sd,mBDce;ECZf,qBAAA;EACA,6BANmB;EAOnB,qBANU;EJ+SI,cG7SR;EH8SQ,mBAAA;AA8uBhB;AA3uBQ;EACI,0BAAA;EACA,mBGvSG;EHwSH,iBAAA;EACA,eAAA;AA6uBZ;AA5uBY;EACI,YAAA;AA8uBhB;AA1uBI;EACI,kBG/SQ;AH2hChB;;AAvuBI;EACI,mBAAA;EACA,oBAAA;AA0uBR","sourcesContent":["@import \"../../../styles/normalize\";\n@import \"../../../styles/variables\";\n@import \"../../../styles/mixin\";\n@import \"../../../styles/global\";\n\n.live-signup {\n    .live-edit-area {\n        position: relative;\n        margin: 0 15px 35px;\n        @include shadow-box();\n        padding: 35px 30px 0px 30px;\n        font-size: $font-size-base;\n        .images-container::-webkit-scrollbar {\n            width: 10px;\n            height: 10px;\n        }\n        .images-container::-webkit-scrollbar-thumb {\n            background: $dark-grey;\n            border-radius: 5px;\n        }\n        .images-container::-webkit-scrollbar-track {\n            background: lighten($light-grey, 17%);\n            border-radius: 5px;\n        }\n        .images-container {\n            max-height: 400px;\n            overflow-y: scroll;\n            margin: 20px auto;\n            padding-top: 12px;\n            display: flex;\n            flex-wrap: wrap;\n            .live-image-container {\n                display: flex;\n                transform: translate3d(0, 0, 0);\n                flex-direction: column;\n                align-items: center;\n                margin-right: 20px;\n                span {\n                    font-size: $font-size-ssm;\n                }\n                margin-bottom: 10px;\n            }\n            .image-number {\n                font-size: $font-size-ssm;\n            }\n            .image-select {\n                position: relative;\n                background-color: #fafafa;\n                display: flex;\n                flex-direction: column;\n                justify-content: flex-end;\n                align-items: center;\n                margin-bottom: 3px;\n                .nf-btn {\n                    border-width: 2px;\n                    width: 90px;\n                    margin: 0;\n                    margin-bottom: 12px;\n                    font-size: $font-size-ssm;\n                }\n            }\n            .image-select,\n            .image-select .live-img {\n                min-height: 150px;\n                width: 120px;\n                .product-detail {\n                    line-height: 15px;\n                }\n            }\n            .product-info .ant-image-img {\n                height: 92px;\n                width: 100px;\n            }\n        }\n        .deliverer-title-area {\n            margin-top: 5px;\n            display: flex;\n            flex-direction: row;\n            .deliverer-close-icon {\n                margin-top: 1px;\n                margin-left: 5px;\n                font-size: $font-size-sm;\n            }\n        }\n        .select-container {\n            display: flex;\n            div:first-child {\n                label {\n                    margin-right: 10px;\n                    text-align: left;\n                }\n            }\n            label {\n                width: 55px;\n            }\n        }\n        .select-container-bottom {\n            display: flex;\n            div:first-child {\n                label {\n                    margin-right: 10px;\n                    text-align: left;\n                }\n            }\n            label {\n                width: 75px;\n            }\n            .nf-select {\n                width: $input-width;\n                &.select-inline-grey {\n                    width: 100px;\n                }\n            }\n            .nf-input-wrapper:not(:first-child) {\n                margin-left: 20px;\n            }\n        }\n        // .text-bold {\n        //   font-weight: bold;\n        //   font-size: $font-size-ssm;\n        // }\n        .info-area {\n            margin: 10px 0 30px;\n            span {\n                font-size: $font-size-ssm;\n                padding-right: 20px;\n            }\n        }\n        .tag-area {\n            margin-top: 30px;\n            margin-bottom: 25px;\n            .tag-title {\n                margin-bottom: 10px;\n            }\n            .nf-select {\n                width: 140px;\n            }\n            .nf-btn {\n                width: 100px;\n            }\n            .text-tag {\n                font-size: $font-size-ssm;\n                display: inline-block;\n                width: 70px;\n            }\n            .tags-container {\n                display: flex;\n                flex-wrap: wrap;\n                max-width: 450px;\n                margin-bottom: 30px;\n                .tag {\n                    font-size: $font-size-ssm;\n                    padding: 5px 22px;\n                    margin: 6px 15px 6px 0;\n                    background-color: $light-grey;\n                    border-radius: 2px;\n                    position: relative;\n                    overflow: visible;\n                }\n            }\n        }\n        .user-info-area {\n            margin-bottom: 30px;\n            width: 280px;\n            .nf-input-wrapper {\n                margin-top: 10px;\n            }\n            .nf-select {\n                width: 200px;\n            }\n            .nf-text-after {\n                right: -21px;\n            }\n        }\n        .title-area {\n            display: flex;\n            flex-direction: column;\n            margin-bottom: 5px;\n            .nf-input-error {\n                right: auto;\n                margin-left: 220px;\n            }\n        }\n        .description-area {\n            display: flex;\n            flex-direction: column;\n            margin-bottom: 10px;\n            textarea {\n                font-size: $font-size-ssm;\n                padding: 9px 10px;\n                resize: none;\n                border: none;\n                border-radius: 3px;\n                background-color: $grey;\n                height: 60px;\n                &:focus-visible {\n                    outline-style: none;\n                    box-shadow: 0 0 0 1px $black;\n                }\n                &:disabled {\n                    color: rgba(0, 0, 0, 0.25);\n                    cursor: not-allowed;\n                    opacity: 1;\n                }\n                &::placeholder {\n                    color: rgba(0, 0, 0, 0.25);\n                }\n            }\n            .textarea-error {\n                color: $cardinal;\n                position: absolute;\n                right: 30px;\n                font-size: $font-size-sssm;\n            }\n        }\n        .image-area {\n            display: flex;\n            flex-direction: column;\n            padding-bottom: 10px;\n            .image-select-area {\n                display: flex;\n                flex-direction: row;\n                .image-select {\n                    position: relative;\n                    height: 200px;\n                    width: 150px;\n                    background-color: #fafafa;\n                    display: flex;\n                    flex-direction: column;\n                    justify-content: flex-end;\n                    align-items: center;\n                    margin: 20px;\n                    margin-bottom: 3px;\n                    .nf-btn {\n                        border-width: 2px;\n                        margin: 0;\n                        margin-bottom: 17px;\n                        font-size: $font-size-ssm;\n                    }\n                }\n                .image-select-label {\n                    text-align: center;\n                    font-size: $font-size-ssm;\n                    margin-bottom: 20px;\n                }\n            }\n        }\n        .check-area {\n            display: flex;\n            flex-direction: column;\n            padding-bottom: 10px;\n            .nf-checkbox-wrapper {\n                display: flex;\n                div {\n                    margin-right: 15px;\n                    label {\n                        font-size: $font-size-ssm;\n                        &::before {\n                            font-size: $font-size-sssm;\n                        }\n                    }\n                }\n            }\n        }\n        .public-date-select {\n            font-size: $font-size-ssm;\n            position: relative;\n            display: flex;\n            align-items: center;\n            &.select-flex-top {\n                align-items: flex-start;\n            }\n            .ant-picker {\n                width: 120px;\n                margin: 0 10px 0 20px;\n                height: 32px;\n                input {\n                    font-size: $font-size-ssm;\n                }\n                .anticon-close-circle {\n                    background-color: $grey;\n                }\n            }\n            .nf-input-wrapper {\n                width: 80px;\n                margin-right: 20px;\n            }\n            .text-checkbox-label {\n                margin: 0 30px 0 17px;\n            }\n            textarea {\n                flex: 1;\n                padding: 8px 8px;\n                resize: none;\n                border: none;\n                background-color: $grey;\n                height: 70px;\n                border-radius: 3px;\n                &:focus-visible {\n                    outline-style: none;\n                    box-shadow: 0 0 0 1px $black;\n                }\n            }\n        }\n        .remand-area {\n            display: flex;\n            position: relative;\n            margin-top: 40px;\n            .text-remind {\n                margin-left: 55px;\n                @include scale-font-size(0.9);\n                color: $black;\n                font-weight: normal;\n            }\n        }\n        .addButton {\n            text-decoration: underline;\n            font-size: $font-size-sm;\n            text-align: right;\n            cursor: pointer;\n            &:hover {\n                opacity: 0.5;\n            }\n        }\n    }\n    .normal-label {\n        font-size: $font-size-ssm;\n    }\n}\n\n.live-signup {\n    .live-edit-area:first-child {\n        margin-bottom: 20px;\n        padding-bottom: 10px;\n    }\n}","/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\n\n/* Document\n   ========================================================================== */\n\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in iOS.\n */\n\nhtml {\n  line-height: 1.15; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n}\n\n/* Sections\n     ========================================================================== */\n\n/**\n   * Remove the margin in all browsers.\n   */\n\nbody {\n  margin: 0;\n}\n\n/**\n   * Render the `main` element consistently in IE.\n   */\n\nmain {\n  display: block;\n}\n\n/**\n   * Correct the font size and margin on `h1` elements within `section` and\n   * `article` contexts in Chrome, Firefox, and Safari.\n   */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/* Grouping content\n     ========================================================================== */\n\n/**\n   * 1. Add the correct box sizing in Firefox.\n   * 2. Show the overflow in Edge and IE.\n   */\n\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/**\n   * 1. Correct the inheritance and scaling of font size in all browsers.\n   * 2. Correct the odd `em` font sizing in all browsers.\n   */\n\npre {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/* Text-level semantics\n     ========================================================================== */\n\n/**\n   * Remove the gray background on active links in IE 10.\n   */\n\na {\n  background-color: transparent;\n}\n\n/**\n   * 1. Remove the bottom border in Chrome 57-\n   * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n   */\n\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n\n/**\n   * Add the correct font weight in Chrome, Edge, and Safari.\n   */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n   * 1. Correct the inheritance and scaling of font size in all browsers.\n   * 2. Correct the odd `em` font sizing in all browsers.\n   */\n\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n   * Add the correct font size in all browsers.\n   */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n   * Prevent `sub` and `sup` elements from affecting the line height in\n   * all browsers.\n   */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n     ========================================================================== */\n\n/**\n   * Remove the border on images inside links in IE 10.\n   */\n\nimg {\n  border-style: none;\n}\n\n/* Forms\n     ========================================================================== */\n\n/**\n   * 1. Change the font styles in all browsers.\n   * 2. Remove the margin in Firefox and Safari.\n   */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n   * Show the overflow in IE.\n   * 1. Show the overflow in Edge.\n   */\n\nbutton,\ninput {\n  /* 1 */\n  overflow: visible;\n}\n\n/**\n   * Remove the inheritance of text transform in Edge, Firefox, and IE.\n   * 1. Remove the inheritance of text transform in Firefox.\n   */\n\nbutton,\nselect {\n  /* 1 */\n  text-transform: none;\n}\n\n/**\n   * Correct the inability to style clickable types in iOS and Safari.\n   */\n\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\n\n/**\n   * Remove the inner border and padding in Firefox.\n   */\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n   * Restore the focus styles unset by the previous rule.\n   */\n\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n   * Correct the padding in Firefox.\n   */\n\nfieldset {\n  padding: 0.35em 0.75em 0.625em;\n}\n\n/**\n   * 1. Correct the text wrapping in Edge and IE.\n   * 2. Correct the color inheritance from `fieldset` elements in IE.\n   * 3. Remove the padding so developers are not caught out when they zero out\n   *    `fieldset` elements in all browsers.\n   */\n\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n   * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n   */\n\nprogress {\n  vertical-align: baseline;\n}\n\n/**\n   * Remove the default vertical scrollbar in IE 10+.\n   */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n   * 1. Add the correct box sizing in IE 10.\n   * 2. Remove the padding in IE 10.\n   */\n\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n   * Correct the cursor style of increment and decrement buttons in Chrome.\n   */\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n   * 1. Correct the odd appearance in Chrome and Safari.\n   * 2. Correct the outline style in Safari.\n   */\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n   * Remove the inner padding in Chrome and Safari on macOS.\n   */\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n   * 1. Correct the inability to style clickable types in iOS and Safari.\n   * 2. Change font properties to `inherit` in Safari.\n   */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* Interactive\n     ========================================================================== */\n\n/*\n   * Add the correct display in Edge, IE 10+, and Firefox.\n   */\n\ndetails {\n  display: block;\n}\n\n/*\n   * Add the correct display in all browsers.\n   */\n\nsummary {\n  display: list-item;\n}\n\n/* Misc\n     ========================================================================== */\n\n/**\n   * Add the correct display in IE 10+.\n   */\n\ntemplate {\n  display: none;\n}\n\n/**\n   * Add the correct display in IE 10.\n   */\n\n[hidden] {\n  display: none;\n}\n","@each $key, $val in $text-align-map {\n  .#{$key} {\n    text-align: #{$val};\n  }\n}\n\nbody {\n  font-family: $font-family;\n}\n\nbutton {\n  border: none;\n  background-color: transparent;\n  outline: none;\n}\n\n.nf-page {\n  padding-top: 60px;\n  min-height: 100vh;\n}\n\n.nf-text-required-style {\n  color: $dark-red;\n  font-size: $font-size-ssm;\n  font-weight: bold;\n}\n\n.nf-analyze-required::after {\n  content: \"*\";\n  font-size: $font-size-sm;\n  text-align: right;\n  color: $cardinal;\n}\n\n.content-body {\n  // min-width: 1400px;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n.display-linebreak {\n  white-space: pre-line;\n}\n\n.validation-error {\n  font-size: $font-size-sssm;\n  color: $cardinal;\n  padding-left: 10px;\n  &.error-title-image {\n    padding-left: 20px;\n  }\n  &.error-remand-reason {\n    position: absolute;\n    right: 2px;\n    bottom: -5px;\n  }\n  &.error-images {\n    position: absolute;\n    right: 20px;\n  }\n}\n\n.sort-span {\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n.action-container {\n  display: flex;\n  justify-content: center;\n  position: relative;\n}\n\n.disabled-area:after {\n  @include disable-area;\n}\n\nspan.text-title {\n  font-size: $font-size-base;\n}\nspan.close-icon {\n  position: absolute;\n  right: -11px;\n  top: -11px;\n  font-size: 22px !important;\n  z-index: 1;\n}\nspan.text-tip {\n  font-size: $font-size-ssm;\n  color: $black;\n  .text-subtip {\n    margin-left: 10px;\n    color: $black;\n    font-weight: normal;\n  }\n}\n.text-required {\n  @include requiredItem();\n}\n.text-blog-code {\n  margin: 10px 0;\n}\n\nul:not([data-slate-node=\"element\"]) {\n  list-style: none;\n}\n\n.ant-table-thead > tr > th {\n  font-weight: bolder;\n  background-color: $grey;\n}\n.ant-table-column-sorter {\n  visibility: collapse;\n}\n.ant-table-ping-left:not(.ant-table-has-fix-left) .ant-table-container::before {\n  box-shadow: none;\n}\n.ant-table-ping-left .ant-table-cell-fix-left-first::after,\n.ant-table-ping-left .ant-table-cell-fix-left-last::after {\n  box-shadow: none;\n}\n.ant-table-ping-right:not(.ant-table-has-fix-right) .ant-table-container::after {\n  box-shadow: none;\n}\n.ant-table-ping-right .ant-table-cell-fix-right-first::after,\n.ant-table-ping-right .ant-table-cell-fix-right-last::after {\n  box-shadow: none;\n}\n\n.ant-pagination-item-active {\n  border: none !important;\n  a {\n    color: $black !important;\n  }\n}\n.ant-pagination-item a {\n  color: $dark-grey;\n  &:hover {\n    color: $dark-grey;\n  }\n}\n.ant-pagination-options {\n  display: none !important;\n}\n\n.ant-pagination-prev,\n.ant-pagination-next,\n.ant-pagination-item-link {\n  outline: none !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n.ant-pagination-item-link:hover {\n  span {\n    color: $dark-grey !important;\n  }\n}\n.ant-pagination-disabled .ant-pagination-item-link:hover {\n  span {\n    cursor: not-allowed !important;\n  }\n}\n\n.ant-pagination-disable {\n  span.anticon:hover,\n  span svg {\n    cursor: not-allowed !important;\n    background-color: red;\n  }\n}\n\n.ant-pagination-item-link-icon .pagination-jump-next {\n  color: $dark-grey !important;\n}\n\n.ant-pagination-jump-prev\n  .ant-pagination-item-container\n  .ant-pagination-item-link-icon,\n.ant-pagination-jump-next\n  .ant-pagination-item-container\n  .ant-pagination-item-link-icon {\n  color: $dark-grey !important;\n}\n\n.ant-select-arrow {\n  color: $black;\n}\n\n.ant-select-item-option {\n  background-color: $white !important;\n  font-size: 11px;\n}\n\n.ant-select-item-option {\n  background-color: $white !important;\n  font-size: 11px;\n}\n\n.ant-modal-wrap {\n  text-align: center;\n  .ant-modal {\n    top: 0;\n    display: inline-block;\n    text-align: left;\n    vertical-align: middle;\n  }\n}\n\n.ant-modal-wrap::before {\n  display: inline-block;\n  width: 0;\n  height: 100%;\n  vertical-align: middle;\n  content: '';\n}\n\n.ant-modal-header {\n  border-bottom: none;\n}\n\n.ant-modal-body {\n  padding-top: 0;\n}\n\n.ant-modal-content {\n  border-radius: $modal-border-radius;\n  overflow-y: hidden;\n  overflow-x: hidden;\n  max-height: 80vh;\n  height: 100%;\n}\n\n.ant-modal-body {\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: 80vh;\n  height: 100%;\n}\n\n.ant-modal-body::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n.ant-modal-body::-webkit-scrollbar-thumb {\n  background: $dark-grey;\n  border-radius: 5px;\n}\n.ant-modal-body::-webkit-scrollbar-track {\n  background: lighten($light-grey, 17%);\n  border-radius: 5px;\n}\n\n.ant-upload.ant-upload-select-picture-card {\n  border: none;\n  height: $upload-picture-card-height;\n  width: $upload-picture-card-width;\n}\n\n.ant-picker-footer {\n  display: none;\n}\n.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {\n  background-color: $black;\n}\n.ant-picker-focused {\n  outline: none;\n  box-shadow: 0 0 0 1px $black;\n  border: 1px solid transparent;\n}\n.ant-picker:hover {\n  border: 1px solid transparent;\n}\n.ant-picker,\n.ant-picker.ant-picker-disabled {\n  border: none !important;\n  outline: none;\n}\n\n.ant-picker-focused {\n  border-color: $black;\n}\n.ant-picker {\n  background-color: $grey;\n  border: 1px solid transparent;\n}\n.ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {\n  border: 1px solid $black;\n}\n\n//input css toDO\n.ant-input,\n.ant-select-selector,\n.ant-input-password,\n.ant-input-number {\n  border: 1px solid transparent !important;\n}\n\n.ant-input:focus,\n.ant-input-focused,\n.ant-input-number:focus,\n.ant-input-number-focused {\n  // border-color: $black !important;\n  box-shadow: 0 0 0 1px $black;\n}\n.ant-input-number-input {\n  // padding: 0 11px;\n  padding: 0 0;\n}\n\n.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input)\n  .ant-select-selector {\n  box-shadow: 0 0 0 1px $black;\n}\n\n// .ant-checkbox-checked {\n//   content: \"\\2713\" !important;\n//   color: $black;\n// }\n.ant-checkbox .ant-checkbox-inner {\n  background-color: white;\n  border-color: $light-grey;\n}\n.ant-checkbox-checked .ant-checkbox-inner {\n  // background-color: white;\n  // border-color: $light-grey;\n  content: \"\\2713\" !important;\n  color: $black;\n  user-select: none;\n\n  &::after{\n    top: 2.5px;\n    left: 0;\n    border: 3px solid #51535b;\n    text-align: center;\n    line-height: 10px;\n    border-radius: 3px;\n    font-weight: bold;\n    background-color: none;\n    display: table;\n    border: 0;\n    opacity: 1;\n    content: \"\\2713\" !important;\n    font-size: 18px;\n    transform: rotateX(45deg);\n    transition:none;\n  }\n}\n.ant-checkbox-wrapper:hover .ant-checkbox-inner,\n.ant-checkbox:hover .ant-checkbox-inner,\n.ant-checkbox-input:focus + .ant-checkbox-inner {\n  border-color: $light-grey;\n}\n.ant-checkbox {\n  box-shadow: 1px 1px 2px #00000029;\n}\n.ant-checkbox-indeterminate .ant-checkbox-inner::after {\n  background-color: #51535b;\n}\n\n.anticon {\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n.ant-table-thead\n  > tr\n  > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {\n  width: 0;\n}\n.ant-table-thead {\n  user-select: none;\n  background-color: $grey;\n}\n.ant-table-tbody > tr.ant-table-row-selected > td {\n  background: $grey;\n  border-color: rgba(0, 0, 0, 0.03);\n}\n.ant-table-sticky-scroll-bar {\n  display: none;\n}\n.ant-image-img {\n  object-fit: cover;\n}\n.ant-image-preview-img {\n  max-width: 70%;\n  max-height: 70%;\n}\n.table-colum-title-cell {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  margin: auto;\n}\n.btn-area {\n  width: 100%;\n  padding-top: 50px;\n  display: flex;\n  justify-content: center;\n}\n.anticon[disabled]:hover {\n  cursor: not-allowed;\n  opacity: 1;\n}\n.anticon:not(.display-icon):hover {\n  opacity: 0.5;\n}\n.ant-input-number-handler-up-disabled,\n.ant-input-number-handler-down-disabled {\n  cursor: pointer;\n}\n","$red: #ff0000;\n$dark-red: #990000;\n$shallow-red: #d89f9f;\n$cardinal: #990000;\n$yellow:#EAAB01;\n$grey: #f3f3f3;\n$dark-grey: #808080;\n$shallow-grey: #f0f0f0;\n$light-grey: #bdbdbd;\n$silver: #7b7b7b;\n$black: #000000;\n$light-black: #242424;\n$transparent-black: #2424241a;\n$white: #ffffff;\n$smoke-white: #f5f5f5;\n\n$font-size-base: 1rem;\n$font-size-xxxl: $font-size-base * 2;\n$font-size-xxl: $font-size-base * 1.625;\n$font-size-xl: $font-size-base * 1.5;\n$font-size-lg: $font-size-base * 1.25;\n$font-size-lm: $font-size-base * 1.175;\n$font-size-sm: $font-size-base * 0.875;\n$font-size-ssm: $font-size-base * 0.75;\n$font-size-sssm: $font-size-base * 0.625;\n$font-size-ssssm: $font-size-base * 0.5;\n\n$font-family: \"Lato\", \"Noto Sans JP\", \"ヒラギノ角ゴ ProN\",\n  \"Hiragino Kaku Gothic ProN\", \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\",\n  \"MS PGothic\", sans-serif;\n\n$text-align-map: (\n  text-align-left: left,\n  text-align-center: center,\n  text-align-right: right,\n);\n\n$input-width: 280px;\n$input-width-short: 80px;\n$input-width-wide-select: 120px;\n$input-width-wide: 160px;\n$input-width-wide-area: 200px;\n$input-width-wider: 240px;\n$input-width-50: 50px;\n$input-width-100: 100px;\n$input-width-125: 125px;\n$input-width-150: 150px;\n$input-width-200: 200px;\n$input-width-220: 220px;\n$input-width-250: 250px;\n$input-width-300: 300px;\n$input-width-350: 350px;\n$input-height: 32px;\n$input-padding-left: 11px;\n$input-placeholder-padding-left: 0px;\n$input-label-width-short: 20px;\n$input-label-width-wide-short: 40px;\n$input-label-width: 80px;\n$input-label-width-wider: 120px;\n$input-label-width-half: 400px;\n$input-label-width-wide: 500px;\n$inout-label-font-size: $font-size-sm;\n$input-wrapper-margin: 5px 0;\n$input-block-margin: 5px 0;\n\n$btn-width: 118px;\n$btn-wider-width: 180px;\n$btn-table-width: 45px;\n$btn-height: 26px;\n$btn-table-height: 30px;\n$btn-margin-vertical: 20px;\n$btn-margin-horizontal: 10px;\n$btn-border-radius: 3px;\n$btn-active-opacity: 0.5;\n$btn-wider-border: 2px solid;\n$btn-wider-margin: 0;\n\n$modal-border-radius: 7px;\n\n$upload-picture-card-width: 150px;\n$upload-picture-card-height: 200px;\n","@mixin shadow-box($radius: 5px) {\n  border-radius: $radius;\n  box-shadow: 0px 0px 10px $shallow-grey;\n}\n\n@mixin scale-font-size(\n  $scale,\n  $transform-origin: left bottom,\n  $display: inline-block\n) {\n  font-size: $font-size-sssm;\n  -webkit-transform: scale($scale);\n  transform: scale($scale);\n  transform-origin: $transform-origin;\n  display: $display;\n}\n\n@mixin disable-area {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  cursor: not-allowed;\n  user-select: none;\n  background: rgba(255, 255, 255, 0.5);\n}\n\n@mixin requiredItem() {\n  &::after {\n    content: \"*\";\n    color: $dark-red;\n    font-size: $font-size-sm;\n  }\n}\n\n@mixin maxRows($rowNum: 2) {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: $rowNum;\n  -webkit-box-orient: vertical;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
